import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";                            // ✅ import par défaut
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
// import "./styles/hover-cards.css";
import "./styles/floating-cart.css";
import "./styles/admin-theme.css";
import "./styles/product-form-elegant.css";
import "./styles/editorial-grid.css";
import "./styles/public-theme.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />                                         {/* ✅ rendu de <App /> */}
  </BrowserRouter>
);
